import React from 'react';
import { Box } from '@mui/material';

import { detailDrawerClosed } from '../store/slices/gridSlice';
import { CheckedRowsActionBar } from './CheckedRowsActionBar';
import { GlobalDialogs } from './GlobalDialogs';
import { useAppDispatch, useAppSelector } from './hooks';
import { DRAWER_WIDTH, ProjectDetailDrawer } from './ProjectDetailDrawer';
import { ProjectsToolbar } from './ProjectsToolbar';
import { ProjectGrid } from './Tools/ProjectGrid';

export function ProjectsPage() {
  const dispatch = useAppDispatch();
  const openProjectGuid = useAppSelector((state) => state.grid.openProjectGuid);
  const focusProjectName = useAppSelector((state) => state.grid.focusProjectNameOnDrawerOpen);

  const drawerOpen = openProjectGuid != null;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexGrow: 1,
        height: '100%',
        backgroundColor: 'canvas.main',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          flexGrow: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          px: 1,
          pb: 1,
          transition: (theme) => theme.transitions.create('margin'),
          marginRight: drawerOpen ? `${DRAWER_WIDTH}px` : 0,
        }}
      >
        <ProjectsToolbar />
        <Box sx={{ flexGrow: 1, height: 'inherit' }}>
          <ProjectGrid />
        </Box>
        <CheckedRowsActionBar />
      </Box>

      {openProjectGuid != null && (
        <ProjectDetailDrawer
          key={openProjectGuid}
          projectGuid={openProjectGuid}
          focusProjectName={focusProjectName}
          onClose={() => dispatch(detailDrawerClosed())}
        />
      )}

      <GlobalDialogs />
    </Box>
  );
}
